'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (oldUpgradeData, newUpgradeData) {
  var upgradeDataIsSame = Boolean(oldUpgradeData.app === newUpgradeData.app && oldUpgradeData.screen === newUpgradeData.screen && oldUpgradeData.upgradeProduct === newUpgradeData.upgradeProduct && oldUpgradeData.uniqueId === newUpgradeData.uniqueId && oldUpgradeData.bundleUrl === newUpgradeData.bundleUrl);

  return !upgradeDataIsSame;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/didUpgradeDataChange.js
// module id = 483
// module chunks = 3 4 5